module.exports = __webpack_public_path__ + "static/media/liongroup01.ab863f25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LionGroup/liongroup01.jpg
// module id = 380
// module chunks = 0